import type {Editor} from "slate";

/**
 * This is a Slate plugin that adds support for inline link elements.
 */
export const withLinks = (editor: Editor): Editor => {
    const {isInline, isSelectable} = editor;

    editor.isInline = (element) => element.type === "link" || isInline(element);

    editor.isSelectable = (element) =>
        element.type === "link" || isSelectable(element);

    return editor;
};
